import { Component, HostBinding, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormControlName, NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { IndicationInterface } from '@app/core/interfaces/indication.interface';
import { ClaimAppointmentInterface } from '@app/my-zone/pages/claims/store/entity/appointment.interface';
import { DateStruct, Notification } from 'outshared-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ins-date-form',
    templateUrl: './date-form.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DateFormComponent,
            multi: true,
        },
    ],
})
export class DateFormComponent implements ControlValueAccessor, OnDestroy {

    @Input() disabled = false;
    @Input() formControlName: FormControlName;
    @Input() appointment: ClaimAppointmentInterface;
    public form: UntypedFormGroup;
    public notifications: Notification[] = [];
    public indication: IndicationInterface = null;
    private subscriptions = new Subscription();

    constructor() {
        this.createForm();
    }

    @HostBinding('style.opacity') get opacity(): number {
        return this.disabled ? 0.25 : 1;
    }

    get value(): IndicationInterface {
        return this.indication;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.writeValue(null);
    }

    /**
     * Control value accessor implentation
     */
    public onChange = (value: IndicationInterface) => {};

    public onTouched(): void {}

    public writeValue(value: IndicationInterface): void {
        if (value !== undefined) {
            this.indication = value;
            this.onChange(value);
        }
    }

    public registerOnChange(fn: (indication: IndicationInterface) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    private createForm(): void {
        this.form = new UntypedFormGroup({
            datum: new UntypedFormControl('', [Validators.required]),
            tijdstip: new UntypedFormControl('', [Validators.required]),
        });

        const dateValueChanges = this.form.controls.datum.valueChanges
            .subscribe((val) => this.onChangeDatum(val));

        const timeslotValueChanges = this.form.controls.tijdstip.valueChanges
            .subscribe((val) => this.onChangeTimeSlot(val));

        this.subscriptions.add(dateValueChanges);
        this.subscriptions.add(timeslotValueChanges);

        if (this.indication !== null) {
            this.writeValue(null);
        }
    }

    private onChangeDatum(value: DateStruct): void {
        this.changeValue();
    }

    private onChangeTimeSlot(value: string): void {
        this.changeValue();
    }

    private changeValue(): void {
        const datum = this.form.controls.datum;
        const tijdstip = this.form.controls.tijdstip;

        if (datum.valid && tijdstip.valid) {
            this.writeValue({
                datum: datum.value,
                tijdstip: tijdstip.value,
            });
        } else {
            this.writeValue(null);
        }
    }
}
